import api from './api';

/** Colonne « Suggestions » de « En cours » : SF les plus rentables de l'élève et création de séance. */

export interface SuggestedSkill {
  id: number;
  name: string;
  centiemes: number;
  rang: number;
  course: { id: number; title: string } | null;
  bac_count: number;
  library_count: number;
}
export interface SuggestedGroup { title: string; skills: SuggestedSkill[] }
export interface SuggestedChapter { title: string; groupes: SuggestedGroup[] }
export interface Suggestions { serie: string | null; note: number; chapitres: SuggestedChapter[] }
export interface BuildItem { skill: number; count: number; source: 'library' | 'bac'; course: boolean; minutes: number }
export interface BuildResult {
  session: { id: number; number: number; name: string };
  exercises: number;
  skipped: { skill: number; reason: string }[];
  timeline_items: number;
}

const suggestionService = {
  async get(studentId: number): Promise<Suggestions> {
    const r = await api.get('/suggestions/', { params: { student: studentId } });
    return r.data;
  },
  async build(studentId: number, items: BuildItem[], title?: string): Promise<BuildResult> {
    const r = await api.post('/sessions/build/', { student: studentId, items, title: title || null });
    return r.data;
  },
  async linkCourse(skillId: number, courseId: number | null): Promise<void> {
    await api.patch(`/skills/${skillId}/`, { course: courseId });
  },
};
export default suggestionService;
